import { nanoid } from "nanoid";
import { getDefaultFontName } from "@/common/constants/font";
import { RGBA } from "@/common/constants/interfaces";
import { Watermark } from "@/common/components/FileCenterProvider";
import { PositionType } from "@/common/constants/interfaces";

export function createWatermark(): Watermark {
    const id = nanoid();
    return {
        id,
        waterMarkType: 'text',
        waterMarkTemplate: '编辑文字',
        fontName: getDefaultFontName(),
        fontSize: 48,
        fontColor: RGBA.fromHex('#000'),
        isBold: false,
        isItalic: false,
        isUnderline: false,
        isStrikethrough: false,
        stroke: null,
        background: null,
        shadowBlur: null,
        shadow: null,
        angel: 0,
        tran: 0,
        position: { positionType: PositionType.RightBottom, offsetX: 8, offsetY: 5, spaceX: 10, spaceY: 10 }
    }
}

export function copyWatermark(watermark: Watermark) {
    const copyWatermark = JSON.parse(JSON.stringify(watermark))
    copyWatermark.id = nanoid()
    return copyWatermark
}